import { motion } from "framer-motion";

const ThemeReveal = ({ theme }) => (
  <motion.div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: theme == "light" ? "#283142" : "#fafafb",
      zIndex: 9999,
      pointerEvents: "none",
    }}
    initial={{ clipPath: "circle(0% at 100% 0%)" }}
    animate={{ clipPath: "circle(150% at 100% 0%)" }}
    transition={{ duration: 0.8, ease: "easeOut" }}
  />
);

export default ThemeReveal;
